/* eslint-disable @calm/react-intl/missing-formatted-message */
'use client';

import { useEffect } from 'react';

import { calmLogger } from '@/utils/calmLogger';

interface GlobalErrorProps {
	error: Error & { digest?: string };
	reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
	useEffect(() => {
		// Log the critical error for debugging
		calmLogger.error('Global App Router error caught', {}, error);

		// Redirect to Pages Router error handling to maintain consistency
		// Use location.replace to avoid adding to history stack
		window.location.replace('/_error');
	}, [error]);

	// Must include html and body since this replaces the root layout
	return (
		<html>
			<body>
				<div>
					<h1>Something went wrong!</h1>
					<p>A critical error occurred. Redirecting...</p>
				</div>
			</body>
		</html>
	);
}
